import type { ReactNode } from "react";

interface SectionProps {
  children?: ReactNode;
  className?: string;
  containerClassName?: string;
}

export default function Section({
  children,
  className = "",
  containerClassName = "",
}: SectionProps) {
  return (
    <section className={`py-16 sm:py-20 ${className}`}>
      <div className={`mx-auto w-full max-w-7xl px-6 ${containerClassName}`}>
        {children}
      </div>
    </section>
  );
}
